import { Logout, Language as LanguageIcon } from "@mui/icons-material";
import { useGetDashboardProfilebyIdQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";

import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { logOut, selectLanguage, setLanguage } from "features/auth/authSlice";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, InputBase } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useEffect } from "react";

const RoundedSelect = styled(Select)(({ theme }) => ({
  background: "#fff",
  borderRadius: "10px",
  paddingLeft: "8px",
  paddingRight: "8px",
  height: "38px",
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  fontWeight: 600,
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  "& fieldset": {
    border: "none",
  },
}));
const ProjectNavbar = ({ id }) => {
  const navigate = useNavigate();
  // console.log("coming id",id)
  //  const projectId = id;
  const projectId = localStorage.getItem("projectId")
    ? localStorage.getItem("projectId")
    : id;
    
  const { t, i18n } = useTranslation();
  const language = useSelector(selectLanguage);
  const { data: userProfile } = useGetDashboardProfilebyIdQuery(
    projectId ? projectId : "",
    { refetchOnMountOrArgChange: true }
  );

  const auth = useAuth();
  const dispatch = useDispatch();

  const handlelogOut = (e) => {
    e.preventDefault();
    localStorage.clear();

    dispatch(logOut());
    auth.removeUser();
    auth.signoutRedirect({ id_token_hint: auth.user.id_token });
  };

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);
  // {console.log("happy",userProfile?.data?.organization_details?.project?.project_name)}
  const isProject=userProfile?.data?.organization_details?.project?.project_name
  return (
    <div style={{ background: "#fbfbfb"}}>
      <nav
        className="d-flex justify-content-between align-items-center border-bottom"
        style={{
          padding: "0.75rem 1.5rem",
          gap: "1rem",
          flexWrap: "wrap",
        }}
      >
        <img
          src="/assets/img/LC-logo.png"
          alt="LC Logo"
          style={{ height: "42px", cursor: "pointer", objectFit: "contain" }}
          onClick={() => navigate("/dashboard")}
        />

        <h4
          style={{
            fontWeight: 800,
            margin: 0,
            textAlign: "center",
            flex: 1,
            textTransform: "capitalize",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            minWidth: 0,
          }}
          title={
            language === "pt-PT" && userProfile?.data?.organization_details?.project?.project_name ===
            "Pilot Study on 360 degree Analytics of Olive Groves Value Chain using Strong AI Frameworks, Portugal"
              ? t("project_name_pt")
              : userProfile?.data?.organization_details?.project?.project_name
          }
        >
          {language === "pt-PT" && userProfile?.data?.organization_details?.project?.project_name ===
            "Pilot Study on 360 degree Analytics of Olive Groves Value Chain using Strong AI Frameworks, Portugal"
            ? t("project_name_pt")
            : userProfile?.data?.organization_details?.project?.project_name}
        </h4>

        <div
          className="d-flex align-items-center gap-3"
          style={{ height: "50px", flexShrink: 0 }}
        >
          {userProfile?.data?.organization_details?.project?.project_name ===
            "Pilot Study on 360 degree Analytics of Olive Groves Value Chain using Strong AI Frameworks, Portugal" && (
            <div
              className="d-flex align-items-center gap-2"
              style={{ height: "40px", flexShrink: 0 }}
            >
              <LanguageIcon style={{ color: "#e9630e", fontSize: "18px" }} />

              <RoundedSelect
                value={language}
                onChange={(e) => dispatch(setLanguage(e.target.value))}
                input={<InputBase />}
                style={{
                  fontSize: "13px",
                  height: "32px",
                  padding: "0 6px",
                  minWidth: "120px",
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      borderRadius: 10,
                      padding: "4px 0",
                      fontSize: "13px",
                    },
                  },
                }}
              >
                <MenuItem
                  value="en"
                  style={{ fontSize: "13px", padding: "4px 10px" }}
                >
                  English
                </MenuItem>

                <MenuItem
                  value="pt-PT"
                  style={{ fontSize: "13px", padding: "4px 10px" }}
                >
                  Portuguese (PT)
                </MenuItem>
              </RoundedSelect>
            </div>
          )}

          <img
            src={userProfile?.data?.organization_details?.project?.project_url}
            style={{
              maxHeight: "100%",
              maxWidth: "160px",
              objectFit: "contain",
            }}
          />
          {!isProject &&userProfile?.data?.organization_details?.organization_name}
          <button
            className="btn bg-primary text-white px-2 py-2 d-flex justify-content-center align-items-center"
            onClick={handlelogOut}
            style={{ borderRadius: "6px", height: "36px", width: "36px" }}
          >
            <Logout style={{ fontSize: "18px" }} />
          </button>
        </div>
      </nav>
    </div>
  );
};

export default ProjectNavbar;
